import BankService from '@/services/BankService'
import applicationConstants from '@/constants/ApplicationConstants'

export default {
  actions: {
    async fetchBankList (ctx, remitationOptionsId) {
      let bankList = []
      if (Array.isArray(remitationOptionsId)) {
        remitationOptionsId.forEach(async (remId, i) => {
          let bankData = await BankService.methods.getBankList(remId)
          bankData = await +bankData.GetBankListResponse.ErrorCode !== 96 ? await bankData.GetBankListResponse.BankData.BankDataItem : null
          if (Array.isArray(bankData) && bankList.length === 0) {
            bankList = await bankData
          } else if (Array.isArray(bankData) && bankList.length > 0) {
            bankList = [ ...bankList, ...bankData ]
          } else if (!!bankData && !Array.isArray(bankData) && bankList.length > 0) {
            bankList = [ ...bankList, ...[bankData] ]
          } else if (!!bankData && !Array.isArray(bankData) && bankList.length === 0) {
            bankList = [bankData]
          }
          if (i === remitationOptionsId.length - 1 && await bankList) {
            ctx.commit(
              'updateBankList',
              [...new Set(await bankList.map(e => e.BankName._text))].map(e => bankList.find(b => e === b.BankName._text))
            )
          }
        })
      } else {
        bankList = await BankService.methods.getBankList(remitationOptionsId)
        ctx.commit(
          'updateBankList',
          bankList.GetBankListResponse.BankData.BankDataItem
        )
      }
    },
    async fetchBankAccounts (ctx) {
      const bankAccounts = await BankService.methods.getBankAccounts()
      ctx.commit(
        'updateBankAccounts',
        bankAccounts.GetBankAccountsResponse.BankAccountsItems.BankAccountsItem
      )
    },
    async fetchCashPickupList (ctx, [allCountries, remitationOptionsId]) {
      ctx.commit(
        'updateCashPickupList',
        allCountries.filter(
          e => e.deliveryMethod === 'Cash Pick up' && +e.remittanceOptionId === +remitationOptionsId
        )
      )
    }
  },
  mutations: {
    updateBankList (state, bankList) {
      state.bankList = Array.isArray(bankList)
        ? bankList
          .map(bank => {
            (Object.values(bank).map((e, key) => {
              const objectKey = Object.keys(bank)[key].charAt(0).toLowerCase() + Object.keys(bank)[key].slice(1)
              bank[objectKey] = e._text
            }))
            return bank
          })
        : bankList
          ? [bankList].map(bank => {
            (Object.values(bank).map((e, key) => {
              const objectKey = Object.keys(bank)[key].charAt(0).toLowerCase() + Object.keys(bank)[key].slice(1)
              bank[objectKey] = e._text
            }))
            return bank
          })
          : []
    },
    updateCashPickupList (state, bankList) {
      state.cashPickupList = bankList
      state.remitationOptions = bankList
    },
    updateBankAccounts (state, bankAccounts) {
      if (bankAccounts) {
        bankAccounts = Array.isArray(bankAccounts) ? bankAccounts : bankAccounts ? [bankAccounts] : []
        const mapBanks = (bank) => {
          (Object.values(bank).map((e, key) => {
            const objectKey = Object.keys(bank)[key]
            if (objectKey === 'SupplementalAccountData') {
              bank[objectKey] = {}
              Object.values(e).map((elChild, keyChild) => {
                const objectKeyChild = Object.keys(e)[keyChild]
                bank[objectKey][objectKeyChild] = {}
                Object.values(elChild).map((elementChildren, keyChildren) => {
                  const objectKeyChildren = Object.keys(elChild)[keyChildren]
                  bank[objectKey][objectKeyChild][objectKeyChildren] = {}
                  bank[objectKey][objectKeyChild][objectKeyChildren] = elementChildren._text
                })
              })
            } else {
              bank[objectKey] = e._text
            }
          }))
          return bank
        }
        state.bankAccounts = bankAccounts.map(mapBanks)
        state.bankAccsForSrcApp = state.bankAccounts.filter(bankItem => bankItem.SourceApp === applicationConstants.financialApp.toString())
      } else {
        state.bankAccounts = []
        state.bankAccsForSrcApp = []
      }
    }
  },
  getters: {
    getBankList (state) {
      return state.bankList
    },
    getCashPickupList (state) {
      return state.cashPickupList
    },
    getRemittanceOptions (state) {
      return state.remitationOptions
    },
    getBankAccounts (state) {
      return state.bankAccounts
    },
    getBankAccountsForConfiguredSourceApp (state) {
      return state.bankAccsForSrcApp
    }
  },
  state: {
    bankList: null,
    bankAccounts: null,
    cashPickupList: null,
    remitationOptions: null,
    bankAccsForSrcApp: null
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bank.js